module.exports = __webpack_public_path__ + "zvetseni-prsou_22_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_22_before.jpg
// module id = 1316
// module chunks = 0